import styled from 'styled-components';

import PolicyCardDecoration from './PolicyCardDecoration';
import rightArrow from '../../images/policy/right-arrow.svg';
import OpdBackground from '../../images/newInsurerPage/OpdBg.svg';
import GmcBackground from '../../images/newInsurerPage/GmcBg.svg';
import RetailBackground from '../../images/newInsurerPage/RetailBg.svg';
import ConsolidatedBackground from '../../images/newInsurerPage/ConsolidatedBg.png';
import PurpleArrow from '../../images/newInsurerPage/purpleArrow.svg';
import lightBlueArrow from '../../images/newInsurerPage/lightBlueArrow.svg';
import redArrow from '../../images/newInsurerPage/redArrow.svg';
import Tappable from 'react-tappable/lib/Tappable';

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  //   justify-content: space-evenly;
  background:
    ${(props) => `url(${props.bgSvg})`}, ${(props) => `${props.bgColor}`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  text-align: center;
  border: ${(props) => (props.borderColor ? '1px solid' : 'none')};
  border-image: ${(props) =>
    props.borderColor ? `${props.borderColor}` : 'none'};
  border-radius: 12px;
  margin-bottom: 1rem;
  position: relative;
  overflow: hidden;
`;
const IconWrapper = styled.div`
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 5px;
  margin: 10px;
`;
const CardIcon = styled.img`
  width: 50px;
  object-fit: contain;
  padding: 4px;
`;

const CardDetails = styled.div`
  text-align: left;
`;

const CardTitle = styled.p`
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
`;

const CardSubtitle = styled.p`
  font-size: 12px;

  line-height: 15px;
  font-weight: 600;
  white-space: pre-wrap;
  color: ${(props) => props.titleColor};
  line-height: 20px;
`;
const CardSubtitleSpan = styled.span`
  font-size: 12px;

  line-height: 15px;
  font-weight: 600;
  white-space: pre-wrap;
  color: ${(props) => props.titleColor};
  line-height: 20px;
`;

const CardSubtitleType2 = styled.p`
  font-size: 10px;
  line-height: 15px;
  font-weight: 600;
  white-space: pre-wrap;
  color: #171616;
  line-height: 20px;
`;

const RightArrow = styled.img`
  filter: ${(props) => (props.filter ? `${props.filter}` : 'none')};
  color: ${(props) => (props.color ? `${props.color}` : 'none')};
  width: 8px;
  transition: transform 0.2s ease;
  transform: ${(props) =>
    props.rotate ? `rotate(${props.rotate}deg)` : 'none'};
`;

const getBackground = (ThemeKey) => {
  switch (ThemeKey) {
    case 'opd-policy-1':
      return OpdBackground;
    case 'gmc-policy':
      return GmcBackground;
    case 'retail':
      return RetailBackground;
    case 'opd-policy-consolidated':
      return ConsolidatedBackground;
    default:
      return GmcBackground;
  }
};
const getBackgroundColor = (ThemeKey) => {
  switch (ThemeKey) {
    case 'opd-policy-1':
      return 'linear-gradient(133deg, #FFF 0%, #EDE3FF 100%)';
    case 'gmc-policy':
      return 'linear-gradient(136deg, #E5F4FF 0%, #C0E8FF 100%)';
    case 'retail':
    case 'opd-policy-consolidated':
      return 'linear-gradient(136deg, #fff3f2 0%, #ffc9c4 100%)';
    default:
      return 'linear-gradient(136deg, #E5F4FF 0%, #C0E8FF 100%)';
  }
};
const getTextColor = (ThemeKey) => {
  switch (ThemeKey) {
    case 'opd-policy-1':
      return 'var(--primary-button, #714fff)';
    case 'gmc-policy':
      return '#3880B4';
    case 'retail':
    case 'opd-policy-consolidated':
      return '#EB0117';
    default:
      return '#3880B4';
  }
};
const getArrow = (ThemeKey) => {
  switch (ThemeKey) {
    case 'opd-policy-1':
    case 'opd-policy-consolidated':
      return PurpleArrow;
    case 'gmc-policy':
      return lightBlueArrow;
    case 'retail':
      return redArrow;
    default:
      return lightBlueArrow;
  }
};

const NewBenefitsCard = (props) => {
  const {
    themeKey,
    sumInsured,
    terminatedAt,
    insurerLogo,
    title,
    subtitle,
    subPolicies,
    url,
    type,
    banner,
  } = props.data;
  const { expanded, onToggle } = props;
  const collapsible = type === 'CONSOLIDATED_POLICY';

  const bgColor = banner?.backgroundColor || getBackgroundColor(themeKey);
  const textColor = banner?.textColor || getTextColor(themeKey);
  const bgSvg = banner?.svgColor ? '' : getBackground(themeKey);

  if (type === 'webView') {
    let imageUrl = url;
    try {
      const urlObj = new URL(url);
      const imageLink = urlObj.searchParams.get('imageLink');
      if (imageLink) {
        imageUrl = imageLink;
      }
    } catch (e) {
      console.error('Error parsing URL:', e);
    }

    return (
      <CardBody
        onClick={props.onTap}
        bgSvg=""
        borderColor=""
        bgColor="transparent"
        style={{
          padding: 0,
          overflow: 'hidden',
          cursor: 'pointer',
        }}
      >
        <img
          src={imageUrl}
          alt={title}
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            borderRadius: '12px',
          }}
        />
      </CardBody>
    );
  }

  // Regular card rendering
  return (
    <CardBody
      onClick={collapsible ? onToggle : props.onTap}
      bgSvg={bgSvg}
      borderColor=""
      bgColor={bgColor}
    >
      {banner?.svgColor && <PolicyCardDecoration color={banner.svgColor} />}
      <div className="flex items-center pr-4">
        <IconWrapper className="w-1/5">
          <CardIcon src={insurerLogo} alt="icon" type={type} />
        </IconWrapper>
        <div className="flex justify-between w-full">
          <div className="flex flex-col items-start justify-start">
            <div
              className="text-title-m font-semibold text-left "
              style={{ lineHeight: '20px' }}
            >
              {title}
            </div>
            <div
              className="text-body-s font-medium"
              style={{ color: textColor }}
            >
              {subtitle}
            </div>
          </div>
          <RightArrow
            src={getArrow(themeKey)}
            //color={getArrowColor(props.data.themeKey)}
            filter={props.filter}
            rotate={collapsible ? (expanded ? -90 : 90) : 0}
          />
        </div>
      </div>
      <div className="text-left self-start w-full flex flex-col pb-4">
        {collapsible && expanded ? null : subPolicies ? (
          <div className="overflow-x-auto whitespace-nowrap flex gap-4 mt-4 px-4">
            {subPolicies?.map((subPolicy, index) => (
              <div
                className="bg-textbox rounded-12 p-12px flex-shrink-0"
                style={{ width: '250px', border: '1px solid #EB011733' }}
                key={index}
              >
                <div className="text-title-m font-semibold">
                  {subPolicy.title}
                </div>
                <div
                  className="text-body-s font-semibold"
                  style={{ color: textColor }}
                >
                  {subPolicy.subTitle}
                </div>
                <div
                  style={{ color: textColor }}
                  className="flex gap-1 font-semibold items-end"
                >
                  <span className="text-chip  text-txtsecondary">
                    Sum Insured
                  </span>
                  <span className="text-body-s">{subPolicy.sumInsured}</span>
                </div>

                <div
                  className="text-sm text-gray-500 flex gap-1 font-semibold items-end"
                  style={{ color: textColor }}
                >
                  <span className="text-chip text-txtsecondary">
                    Policy Expiry:
                  </span>
                  <span className="text-body-s">{subPolicy.terminatedAt}</span>
                </div>
                {subPolicy.coiURL && (
                  <div
                    onClick={() => window.open(subPolicy.coiURL, '_blank')}
                    className="w-full border border-txtsecondary-shades7 rounded-12 text-txtlight text-chip font-semibold text-center py-1 mt-2 cursor-pointer clickable"
                  >
                    Download COI
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="px-4" style={{ paddingLeft: '80px' }}>
            <CardSubtitleType2>
              Sum Insured:{' '}
              <CardSubtitleSpan titleColor={textColor}>
                {sumInsured}
              </CardSubtitleSpan>
            </CardSubtitleType2>
            <CardSubtitleType2>Exp Date: {terminatedAt}</CardSubtitleType2>
          </div>
        )}
      </div>
    </CardBody>
  );
};

export default NewBenefitsCard;
